import { Page } from '@/core/architecture'

import { ConsoleUsersTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * ConsoleUsers Page
 * Implemented as a practical sample.
 */
export const ConsoleUsers: Page = () => {
  const { state, actions } = useViewModel()

  return <ConsoleUsersTemplate state={state} {...actions} />
}
